/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Field_CarrierInputs */

const vi_cdo_field_carrier = /** @type {(inputs: Cdo_Field_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị giao`)
};

/**

* @param {Cdo_Field_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_field_carrier = /** @type {((inputs?: Cdo_Field_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Field_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_field_carrier(inputs)
});